export const SITECODE = 'apfym'
export const APP_ID = 366

export const MODAL_OPEN         = 'MODAL_OPEN'
export const MODAL_START_CLOSE  = 'MODAL_START_CLOSE'
export const MODAL_FINISH_CLOSE = 'MODAL_FINISH_CLOSE'
export const MODAL_UPDATE       = 'MODAL_UPDATE'

export const DETAIL_PANEL_OPEN         = 'DETAIL_PANEL_OPEN'
export const DETAIL_PANEL_START_CLOSE  = 'DETAIL_PANEL_START_CLOSE'
export const DETAIL_PANEL_FINISH_CLOSE = 'DETAIL_PANEL_FINISH_CLOSE'

export const CHANGE_BREAKPOINT  = 'CHANGE_BREAKPOINT'
export const SET_ACTIVE_TAB     = 'SET_ACTIVE_TAB'
export const GENERIC_APP_ERROR  = 'GENERIC_APP_ERROR'
